import { Component, Input, Output, EventEmitter, forwardRef, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';


/**
   * Logger Factory
   * @namespace value: current value of checkbox
   * @namespace items: number of element to show
   * @namespace selectedItems: bring to the parent the value selected 
   * <ute-checkbox [items]="items || {name: 'test', value: false}" (selectedItems)="test($event)"></ute-checkbox>
*/

@Component({
  selector: 'ute-checkbox',
  templateUrl: 'ute-checkbox.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(()=> UteCheckboxComponent),
    multi: true
  }]
})
export class UteCheckboxComponent {
  @Input() value: string;
  @Input() small: string;
  @Input() items: any[];
  @Input() link: any;
  @Output() selectedItems= new EventEmitter;

  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>();

  public valueCheckbox: string = '';
  public innerValue: any[];
  private propagateChange = (_: any) => { };
  private propagateTouch = () => { };

  constructor() {
  
  }

  onBlur(event) {
    this.propagateTouch();
    this.blur.emit(event);
  }
  public writeValue(obj: any) {
    if(obj) {
      this.valueCheckbox = obj;
    } 
  }
  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }
  
  onChangeCheckbox(item){
    this.propagateChange(item);
    this.selectedItems.emit(this.items.filter((e) => (e.value === true)));
  }

  ngOnChanges(change:SimpleChanges){
    if(change && change.link){
      this.link = change.link.currentValue;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/atoms/ute-checkbox/ute-checkbox.component.ts